(function () {
  if (window.socialGalleryInit) return;
  window.socialGalleryInit = true;

  let current = null;
  let lastHovered = null;

  function syncIcons(video) {
    const tile = video.closest('.video-tile');
    if (!tile) return;
    tile.querySelector('.play-icon')?.classList.toggle('opacity-0', !video.paused);
    tile.querySelector('.pause-icon')?.classList.toggle('opacity-0', video.paused);
    tile.querySelector('.muted-icon')?.classList.toggle('opacity-0', !video.muted);
    tile.querySelector('.unmuted-icon')?.classList.toggle('opacity-0', video.muted);
    tile.querySelector('.video-play-btn')?.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    tile.querySelector('.video-audio-btn')?.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  }

  function getVideo(tile) {
    const placeholder = tile.querySelector('[data-social-video]');
    if (!placeholder) return null;

    const existing = placeholder.querySelector('video');
    if (existing) return existing;

    let sources = [];
    try {
      sources = JSON.parse(placeholder.dataset.sources || '[]');
    } catch (e) {
      return null;
    }
    if (!sources.length) return null;

    const video = document.createElement('video');
    video.className = 'w-full h-full object-cover video-element';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    if (placeholder.dataset.poster) video.poster = placeholder.dataset.poster;

    sources.forEach((s) => {
      const source = document.createElement('source');
      source.src = s.url;
      source.type = s.mime || 'video/mp4';
      video.appendChild(source);
    });

    ['play', 'pause', 'volumechange'].forEach((name) => {
      video.addEventListener(name, () => syncIcons(video));
    });

    const poster = placeholder.querySelector('img');
    if (poster) poster.replaceWith(video);
    else placeholder.appendChild(video);

    return video;
  }

  function play(tile, unmute) {
    const video = getVideo(tile);
    if (!video) return;

    if (current && current !== video) {
      current.pause();
      current.currentTime = 0;
      current.muted = true;
      syncIcons(current);
    }

    if (unmute) video.muted = false;
    video
      .play()
      .then(() => {
        current = video;
        syncIcons(video);
      })
      .catch(() => syncIcons(video));
  }

  document.addEventListener('mouseover', (e) => {
    const tile = e.target.closest?.('.social-gallery .video-tile');
    if (tile === lastHovered) return;
    lastHovered = tile;
    if (tile) play(tile, false);
  });

  document.addEventListener('click', (e) => {
    const tile = e.target.closest?.('.social-gallery .video-tile');
    if (!tile) return;

    const playBtn = e.target.closest('.video-play-btn');
    const audioBtn = e.target.closest('.video-audio-btn');
    const video = getVideo(tile);
    if (!video) return;

    if (audioBtn) {
      video.muted = !video.muted;
      if (video.paused) play(tile, false);
      else syncIcons(video);
      return;
    }

    if (playBtn) {
      if (video.paused) play(tile, false);
      else video.pause();
      return;
    }

    if (video.paused) play(tile, true);
    else video.pause();
  });
})();
